import React, { useEffect, useState } from "react";
import Seo from "../../../Components/SeoComponent/Seo";
import Header from "../../../Components/Header";
import { useService } from "../../../context/ServiceContext";
import { Copy, FileJson, ListCheck, Loader } from "lucide-react";
import { verifyPrefillv3Details, verifyPrefillv4Details } from "../../../Services/ApiTestService/apiTestService";
import { fetchProfile } from "../../../Services/ApiTestService/aadharTestService";
import { showErrorToast, showSuccessToast } from "../../../utils/toastUtils";
import { isNumeric } from "validator";
import { Link } from "react-router-dom";
import { IoArrowBackCircleOutline } from "react-icons/io5";

function Prefillv4() {
  const { serviceName } = useService();

  const [isLoading, setIsLoading] = useState(false);
  const [response, setResponse] = useState(null);

  const [mobileNumber, setMobileNumber] = useState("");
  const [inputError, setInputError] = useState(null);
  const [isJsonCopied, setIsJsonCopied] = useState(null);

  const [profileData, setProfileData] = useState(null);
  let apiResponse;

  const isNumber = (value) => {
    if (!value) return false;

    return isNumeric(value, { no_symbols: true });
  };

  const handleCopy = (data) => {
    navigator.clipboard
      .writeText(JSON.stringify(data, null, 2))
      .then(() => showSuccessToast("Copied!"));

    setIsJsonCopied(true);
  };

  // ---------------- VERIFY CONSUMER ----------------
  const handleVerifyConsumer = async () => {
    if (!profileData) return;

    const validateNumber = isNumber(mobileNumber);

    if (!validateNumber) {
      return setInputError("⚠️ Please enter number only in Mobile No. field");
    } else if (mobileNumber.length < 10) {
      return setInputError("⚠️ Enter at least 10 digits in Mobile No. field");
    }

    try {
      setInputError(null);
      setIsLoading(true);
      setResponse(null);

      const res = await verifyPrefillv4Details({
        api_id: profileData.user_id,
        api_key: profileData.api_key,
        token_id: profileData.token_id,
        mobile: mobileNumber.trim(),
      });

      if (res) {
        apiResponse = res;
      }
      setResponse(apiResponse);

      if (res?.status?.code === 200) {
        showSuccessToast(res?.message || "Success");
      } else if (res?.status?.code === 422) {
        showErrorToast(res?.data?.message || "invalid details ");
      } else if (res?.status?.code === 500) {
        showErrorToast(res?.data?.message || "server error");
      } else if (!res.success) {
        showErrorToast(res?.data?.message || "verificaton failed");
      } else {
        showErrorToast(res?.data?.message || "something went wrong");
      }
    } catch (error) {
      console.error(error);
      showErrorToast("Server error");
    } finally {
      setIsLoading(false);
    }
  };

  // ---------------- FETCH PROFILE ----------------
  useEffect(() => {
    const loadProfile = async () => {
      try {
        setIsLoading(true);
        const res = await fetchProfile();
        setProfileData(res?.data || null);
      } catch (error) {
        console.error(error);
        showErrorToast("Failed to fetch profile");
      } finally {
        setIsLoading(false);
      }
    };

    loadProfile();
  }, []);

  return (
    <>
      <Seo />
      <Header heading={serviceName} />

      {isLoading && (
        <div className="flex justify-center mt-6">
          <Loader className="animate-spin" />
        </div>
      )}

              <div className="col-span-2 md:col-span-6 flex justify-end">
            
                         <Link
                      to="/TestMaster"
                      className="flex items-center gap-1 text-white bg-green-600 hover:bg-green-700 px-1 py-1 rounded-md font-semibold shadow-md transition duration-300"
                    >
                      <span>Go Back</span>
                      <IoArrowBackCircleOutline size={24} />
                    </Link>
            
                  </div>

      <div className="w-full min-h-screen flex flex-col items-center justify-start py-14">
        {/* ---------------- FORM ---------------- */}
        <div className=" max-w-3xl border rounded-md sm:p-6 mt-6 bg-white">
          <div className="flex items-center flex-wrap gap-4">
            {/* Mobile */}
            <div className="flex items-center gap-4">
              <label className="w-32 font-bold">
                Mobile No <span className="text-red-600">*</span>
              </label>
              <input
                type="text"
                maxLength={10}
                value={mobileNumber}
                onChange={(e) => setMobileNumber(e.target.value)}
                className="flex-1 border border-gray-400 rounded-md px-3 h-[38px]"
                placeholder="Eg: 9187864534"
              />
            </div>

            {/* show input errors */}

            {inputError && (
              <div className="text-red-800 text-xl font-bold">{inputError}</div>
            )}

            {/* Verify Button */}
            <div className="flex justify-end ">
              <button
                disabled={isLoading || !mobileNumber}
                onClick={handleVerifyConsumer}
                className="px-6 py-2 bg-gradient-to-br hover:bg-black active:bg-green-600 from-blue-400 to-blue-800 text-white rounded-sm disabled:opacity-50"
              >
                Verify
              </button>
            </div>
          </div>
        </div>

        {/* response message */}

        {response && (
          <div
            className={` ${response.status?.code === 500 || response.status?.code === 422 ? "text-red-500" : "text-green-600"} py-4 text-2xl font-bold`}
          >
            {response?.data?.message || response?.message}
          </div>
        )}

        {/* instructions */}

        <div>
          <div className="bg-gray-200 border border-gray-400 p-5 mt-12 rounded-md">
            <h3 className="font-bold text-lg mb-2">
              ‼️ Important Instructions <span className="text-red-600">*</span>
            </h3>

            <p className="text-sm leading-relaxed">
              Please enter a valid mobile number. Clicking the Verify button.
              After successful verification, the system will return the response
              in structured format, including contact details associated with
              the provided details. You may review and copy the data for your
              reference or further use.
            </p>
          </div>
        </div>

        {/* ---------------- RESULT ---------------- */}
        {response?.status?.code === 200 && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-10 w-full max-w-6xl">
            {/* -------- JSON VIEW -------- */}
            <div className="bg-gray-900 relative text-green-300 p-4 rounded-md overflow-auto">
              <button
                onClick={() => handleCopy(response)}
                className="absolute text-white top-4 right-8"
              >
                {isJsonCopied ? "copied" : <Copy />}
              </button>
              <p className="font-bold mb-2 text-2xl flex items-center justify-start md:justify-center gap-2 text-white">
                <FileJson /> JSON response
              </p>
              <hr className="mb-8" />{" "}
              <pre className="text-[16px]">
                {JSON.stringify(response, null, 2)}
              </pre>
            </div>

            {/* -------- USER DETAILS -------- */}
            <div className="bg-gray-200 p-5 rounded-md">
              <h2 className="text-2xl flex items-center justify-center gap-2  font-bold text-blue-500 mb-1">
                <ListCheck /> All Details
              </h2>
              <hr className="mb-8" />

              {/* BASIC INFO */}
              <div className="space-y-2 text-sm">
                <div>
                  <span className="font-semibold text-gray-600 w-40 inline-block">
                    Name:
                  </span>
                  <span className="text-gray-900">
                    {response?.data?.name || "N/A"}
                  </span>
                </div>

                <div>
                  <span className="font-semibold text-gray-600 w-40 inline-block">
                    DOB:
                  </span>
                  <span className="text-gray-900">
                    {response?.data?.dob || "N/A"}
                  </span>
                </div>

                <div>
                  <span className="font-semibold text-gray-600 w-40 inline-block">
                    Gender:
                  </span>
                  <span className="text-gray-900">
                    {response?.data?.gender || "N/A"}
                  </span>
                </div>
              </div>

              {/* ADDRESSES */}
              {/* {response?.status?.code === 200 &&
                response?.data?.addresses?.length > 0 && (
                  <div className="mt-8">
                    <h3 className="font-bold text-xl text-gray-800 mb-4">
                      Addresses
                    </h3>

                    <div className="space-y-3">
                      {response.data.addresses.map((addr, index) => (
                        <div
                          key={index}
                          className="border p-4 rounded-md bg-blue-500 text-white"
                        >
                          {addr}
                        </div>
                      ))}
                    </div>
                  </div>
                )} */}

                {response?.data?.address?.length > 0 && (
  <div className="mt-8">
    <h3 className="font-bold text-xl text-gray-800 mb-4">
      Addresses
    </h3>

    <div className="space-y-3">
      {response.data.address.map((addr, index) => (
        <div
          key={index}
          className="border p-4 rounded-md bg-blue-500 text-white"
        >
          <div>{addr.first_line_of_address}</div>
          <div>{addr.second_line_of_address}</div>
          <div>{addr.third_line_of_address}</div>
          <div>{addr.city}, {addr.state}</div>
          <div>{addr.postal_code}</div>
        </div>
      ))}
    </div>
  </div>
)}

              {/* PHONE NUMBERS */}
              {response?.data?.phone_numbers?.length > 0 && (
                <div className="mt-8">
                  <h3 className="font-bold text-xl text-gray-800 mb-3">
                    Phone Numbers
                  </h3>

                  <div className="border p-4 rounded-md bg-blue-500 text-white space-y-1">
                    {response.data.phone_numbers.map((phone, i) => (
                      <div key={i}>
                        <span className="font-semibold text-blue-200 w-32 inline-block">
                          Phone:
                        </span>
                        {phone || "N/A"}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* EMAILS */}
              {response?.data?.email?.length > 0 && (
                <div className="mt-8">
                  <h3 className="font-bold text-xl text-gray-800 mb-3">
                    Emails
                  </h3>

                  <div className="border p-4 rounded-md bg-blue-500 text-white space-y-1">
                    {/* {response.data.email.map((email, i) => (
                      <div key={i}>
                        <span className="font-semibold text-blue-200 w-32 inline-block">
                          Email:
                        </span>
                        {email || "N/A"}
                      </div>
                    ))} */}

                   {response?.data?.email && (
  <div className="mt-8">
    <h3 className="font-bold text-xl text-gray-800 mb-3">
      Email
    </h3>

    <div className="border p-4 rounded-md bg-blue-500 text-white">
      <span className="font-semibold text-blue-200 w-32 inline-block">
        Email:
      </span>
      {response.data.email}
    </div>
  </div>
)}
                  </div>
                </div>
              )}

              {/* PAN NUMBERS */}
              {response?.data?.pan_number?.length > 0 && (
                <div className="mt-8">
                  <h3 className="font-bold text-xl text-gray-800 mb-3">
                    PAN Numbers
                  </h3>

                  <div className="border p-4 rounded-md bg-blue-500 text-white space-y-1">
                    {/* {response.data.pan_number.map((pan, i) => (
                      <div key={i}>
                        <span className="font-semibold text-blue-200 w-32 inline-block">
                          PAN:
                        </span>
                        {pan || "N/A"}
                      </div>
                    ))} */}

                    {response?.data?.pan && (
  <div className="mt-8">
    <h3 className="font-bold text-xl text-gray-800 mb-3">
      PAN
    </h3>

    <div className="border p-4 rounded-md bg-blue-500 text-white">
      <span className="font-semibold text-blue-200 w-32 inline-block">
        PAN:
      </span>
      {response.data.pan}
    </div>
  </div>
)}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default Prefillv4;
